import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/home/home";
import NotFound from "../pages/not-found/not-found";
import GAListener from "../components/galistener";

const AppRoutes = () => {
	return (
		<BrowserRouter>
			<GAListener />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		</BrowserRouter>
	);
};

export default AppRoutes;
